import React from 'react';
import PropTypes from 'prop-types';
import Folder from '@mui/icons-material/Folder';

import { Typo } from 'uikit/content';

import VideoBrowseHeader from './videoBrowseHeader';
import VideoBrowseContent from './videoBrowseContent';

import styles from '../styles/videoTopicContent.module.scss';

const VideoTopicContent = ({
  content,
  onButtonGroupChanged,
  view,
  onLoadMore,
  isExpanded,
}) => (
  <div className={styles.container}>
    <VideoBrowseHeader onButtonGroupChanged={onButtonGroupChanged} view={view} />
    <div>
      {!isExpanded ? (
        <VideoBrowseContent
          browse={content}
          view={view}
          onLoadMore={onLoadMore}
          hasMore={false}
        />
      ) : content.map((section) => (
        <div className={styles.content}>
          <div className={styles.sectionHeader}>
            <Folder className={styles.sectionHeaderIcon} sx={{ height: 24, width: 24 }} />
            <Typo element="span" className={styles.sectionHeaderName} variant="d02">{section.name}</Typo>
          </div>
          <div className={styles.sectionDescription}>
            <Typo variant="span">{section.description}</Typo>
          </div>
          <VideoBrowseContent
            browse={section.content}
            view={view}
            onLoadMore={onLoadMore}
            hasMore={false}
          />
        </div>
      ))}
    </div>
  </div>
);

VideoTopicContent.defaultProps = {
  view: '',
  onButtonGroupChanged: () => {},
  onLoadMore: () => {},
};

VideoTopicContent.propTypes = {
  view: PropTypes.string,
  onButtonGroupChanged: PropTypes.func,
  onLoadMore: PropTypes.func,
  content: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default React.memo(VideoTopicContent);
